<template>
  <div class="mb-8">
    <h3 class="pb-1">
      <v-icon class="demographic-icon">{{ icon[filter] }}</v-icon>
      {{ $t(`filters.demographics.${filter}.label`) }}
    </h3>
    <AppBarChart :bar-data="percentageData" />
  </div>
</template>

<script>
import {
  mdiGenderMaleFemale,
  mdiSchool,
  mdiCity,
  mdiCashUsd,
  mdiCakeVariant,
  mdiAccessPointNetwork
} from "@mdi/js";
import { mapGetters } from "vuex";
import { format } from "d3-format";
import AppBarChart from "@/components/AppBarChart.vue";
export default {
  props: {
    filter: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      icon: {
        gender: mdiGenderMaleFemale,
        education: mdiSchool,
        environment: mdiCity,
        income: mdiCashUsd,
        age: mdiCakeVariant,
        internet: mdiAccessPointNetwork
      }
    };
  },
  components: {
    AppBarChart
  },
  computed: {
    ...mapGetters(["filteredCount", "filteredData", "filteredDemographicData"]),
    getDemographicData() {
      return this.filteredDemographicData(this.filter);
    },
    percentageData() {
      return this.getDemographicData.map(d => {
        const value = d.value ? d.value / this.filteredCount : 0;
        return {
          key: d.key,
          label: this.$t(
            `filters.demographics.${this.filter}.options.${d.key}`
          ),
          value,
          formated: value ? format(".0%")(value) : "",
          color: this.$vuetify.theme.themes.light.section1
        };
      });
    }
  }
};
</script>